<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            title="Объединить в гарнитур"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <p>Выбрано изделий: {{ productIds.length }}</p>
            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label required" for="art_code"
                    >Артикул гарнитура</label
                >

                <garniture-autocomplete
                    v-if="isOpen"
                    :initial-garniture="garniture"
                    :products-count="productIds.length"
                    :brand-id="brandId"
                    @garnitureChange="onGarnitureChange"
                />

                <div
                    v-if="
                        $v.garniture.set_article.$dirty &&
                            $v.garniture.set_article.$invalid
                    "
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
                <div v-if="errors.setItemsToSet.error" class="error-label">
                    {{ errors.setItemsToSet.error }}
                </div>
                <div v-if="errors.createSet.error" class="error-label">
                    {{ errors.createSet.error }}
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { mapState, mapGetters, mapActions } from 'vuex'

import GarnitureAutocomplete from '@/components/Cabinet/Supplier/Product/GarnitureAutocomplete.vue'
import { required } from 'vuelidate/lib/validators'

const validations = {
    garniture: {
        set_article: { required }
    }
}

export default {
    name: 'ChangeGarnitureMass',
    components: { Modal, GarnitureAutocomplete },
    props: {
        productIds: {
            type: Array,
            required: true
        },
        brandId: {
            // eslint-disable-next-line
            type: Number | String,
            default: ''
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            garniture: {
                id: '',
                set_article: ''
            }
        }
    },
    computed: {
        ...mapState('supplierSets', ['errors'])
    },
    validations,
    methods: {
        ...mapActions('supplierSets', [
            'setItemsToSet',
            'createSet',
            'resetErrors'
        ]),
        closeModal() {
            this.garniture = {
                id: '',
                set_article: ''
            }
            this.$v.$reset()
            this.resetErrors()
            this.$emit('closeModal')
            this.$emit('onChangeGarnitureMassSaved')
        },

        async saveModal() {
            if (this.loading) return
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true

                if (this.garniture.id) {
                    //Добавляем изделия в существующий гарнитур
                    let data = {
                        SetID: this.garniture.id,
                        Items: this.productIds
                    }

                    await this.setItemsToSet(data)
                } else {
                    //создаем новый гарнитур с изделиями

                    let data = {
                        BrandID: this.brandId,
                        SetArticle: this.garniture.set_article,
                        Items: this.productIds
                    }

                    await this.createSet(data)
                }

                this.loading = false

                if (
                    Object.keys(this.errors.setItemsToSet).length ||
                    Object.keys(this.errors.createSet).length
                ) {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка'
                    })
                } else {
                    this.$notify({
                        type: 'success',
                        text: 'Выполнено успешно'
                    })
                    this.closeModal()
                }
            } else {
                this.$notify({
                    type: 'error',
                    text: 'Форма заполнена некорректно'
                })
            }
        },
        onGarnitureChange(val) {
            this.garniture = val
        }
    }
}
</script>
